import {
    LOAD_CUSTOMER_INSIGHT_ORDER_TYPE_SEARCH
} from "../../../actions/types";

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_CUSTOMER_INSIGHT_ORDER_TYPE_SEARCH:
            return [...action.payload]
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/reducers/restaurants/customerInsight/CustomerInsightOrderTypeReducer.js